// src/pages/Admin/TotalWithdraw.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";

export default function TotalWithdraw() {
  const [funds, setFunds] = useState([]);
  const [filteredFunds, setFilteredFunds] = useState([]);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    fetchWithdrawFunds();
  }, []);

  const fetchWithdrawFunds = async () => {
    try {
      const res = await axios.get("https://api.earnmoney0.top/admin/approved-withdraws");
      if (res.data.success) {
        setFunds(res.data.funds || []);
        setFilteredFunds(res.data.funds || []);
      }
    } catch (err) {
      console.error("❌ Fetch Withdraw Funds Error:", err);
    }
  };

  useEffect(() => {
    let data = [...funds];

    if (search.trim()) {
      data = data.filter(
        (f) =>
          f.userId?.username?.toLowerCase().includes(search.toLowerCase()) ||
          f.userId?.email?.toLowerCase().includes(search.toLowerCase()) ||
          f.transactionId?.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (startDate) {
      data = data.filter((f) => new Date(f.createdAt) >= new Date(startDate));
    }
    if (endDate) {
      data = data.filter((f) => new Date(f.createdAt) <= new Date(endDate));
    }

    setFilteredFunds(data);
  }, [search, startDate, endDate, funds]);

  const exportToCSV = () => {
    if (filteredFunds.length === 0) {
      alert("⚠️ No data to export!");
      return;
    }

    const headers = ["Username,Phone,Method,Number,Amount (৳),Status,Date\n"];
const rows = filteredFunds.map((f) => {
  const date = new Date(f.createdAt).toLocaleString("en-GB");
  return `${f.userId?.name || "Unknown"},${f.userId?.phone || "N/A"},${f.method},${f.number || "N/A"},${f.amount},${f.status},${date}`;
});

    const blob = new Blob([headers + rows.join("\n")], {
      type: "text/csv;charset=utf-8;",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Approved_Withdraws_${new Date().toISOString().slice(0, 10)}.csv`;
    link.click();
  };

  return (
    <div className="total-withdraw-page">
      <style>{`
        .total-withdraw-page {
          min-height: 100vh;
          background-color: #0b0f1a;
          color: white;
          padding: 24px;
          font-family: sans-serif;
        }
        h2 {
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 24px;
          color: #f97316;
        }
        .filters {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-bottom: 24px;
        }
        .filters input[type=text], .filters input[type=date] {
          padding: 10px;
          border-radius: 8px;
          border: 1px solid #444;
          background: #111827;
          color: white;
          font-size: 16px;
        }
        .filters button {
          padding: 10px 16px;
          border: none;
          border-radius: 8px;
          background: #f97316;
          color: black;
          font-weight: 600;
          cursor: pointer;
          transition: 0.3s;
        }
        .filters button:hover {
          background: #ea580c;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          background: #111827;
          border-radius: 12px;
          overflow: hidden;
        }
        th, td {
          padding: 12px;
          text-align: left;
          border-bottom: 1px solid #333;
        }
        th {
          color: #f97316;
          text-transform: uppercase;
        }
        tr:hover {
          background: #1f2937;
        }
        @media (max-width: 640px) {
          h2 {
            font-size: 22px;
          }
          th, td {
            padding: 8px;
          }
          .filters input[type=text], .filters input[type=date], .filters button {
            font-size: 14px;
          }
        }
      `}</style>

      <div className="header">
        <h2>💸 Total Withdraw — Approved</h2>
        <button onClick={exportToCSV}>⬇️ Export CSV</button>
      </div>

      <div className="filters">
        <input
          type="text"
          placeholder="🔍 Search username, email, or Txn ID..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <label>From:</label>
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
        <label>To:</label>
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Username</th>
<th>Phone</th>
<th>Method</th>
<th>Number</th>
<th>Amount (৳)</th>
<th>Status</th>
<th>Date</th>
            </tr>
          </thead>
          <tbody>
            {filteredFunds.length === 0 ? (
              <tr>
                <td colSpan="7" style={{ textAlign: "center", color: "#888", padding: "12px" }}>
                  No approved withdrawals found
                </td>
              </tr>
            ) : (
              filteredFunds.map((fund) => (
                <tr key={fund._id}>
                  <td>{fund.userId?.name || "Unknown"}</td>
<td>{fund.userId?.phone || "N/A"}</td>
<td>{fund.method}</td>
<td>{fund.number || "N/A"}</td>
<td style={{ color: "#f97316", fontWeight: 600 }}>৳{fund.amount}</td>
<td>
  <span style={{ background: "#f97316", color: "black", padding: "4px 10px", borderRadius: "6px", fontWeight: 600, fontSize: "12px" }}>
    {fund.status}
  </span>
</td>
<td style={{ color: "#ccc" }}>
  {new Date(fund.createdAt).toLocaleString("en-GB")}
</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}